<div
  class="modal-action-bar-container"
  [class.no-shadow]="scrollService.reachedBottomOfContent$ | async"
  data-test="action-bar"
>
  <mode-info-banner
    [schedule]="schedule"
    [slackChannel]="slackChannel"
    [entity]="entity"
    [notifyType]="notifyType"
    data-test="info-banner"
  >
  </mode-info-banner>
  <div class="modal-action-bar">
    <div class="modal-nav-back">
      <capra-button
        *ngIf="!initialSchedule"
        class="no-padding"
        icon="icon-back"
        text="Back"
        type="button"
        variant="secondary"
        [color]="'neutral'"
        (clicked)="backClicked.emit($event)"
        data-test="back-button"
      ></capra-button>
    </div>
    <capra-button
      *ngIf="!isCreatingNewSchedule && initialSchedule"
      class="delete-button"
      variant="secondary"
      color="alert"
      text="Delete"
      (clicked)="deleteClicked.emit($event)"
      data-test="delete-button"
    ></capra-button>
    <div class="modal-nav-proceed">
      <capra-button
        class="cancel no-padding"
        text="Cancel"
        type="button"
        variant="secondary"
        [color]="'neutral'"
        (clicked)="cancelClicked.emit($event)"
        data-test="cancel-button"
      ></capra-button>
      <capra-button
        *ngIf="ShowNamedSchedules"
        class="no-padding"
        [disabled]="disableCreateButton || false"
        text="{{
          notifyType === 'none' || notifyType === 'slack'
            ? isCreatingNewSchedule
              ? 'Create schedule'
              : 'Update schedule'
            : isCreatingNewSchedule
            ? 'Create & add subscribers >'
            : 'Manage subscribers >'
        }}"
        type="submit"
        data-test="create-update-next-button"
      ></capra-button>
      <capra-button
        *ngIf="!ShowNamedSchedules"
        class="no-padding"
        text="{{
          notifyType === 'none' || notifyType === 'slack'
            ? isCreatingNewSchedule
              ? 'Create schedule'
              : 'Update schedule'
            : isCreatingNewSchedule
            ? 'Create & add subscribers >'
            : 'Manage subscribers >'
        }}"
        type="submit"
        data-test="create-update-next-button"
      ></capra-button>
    </div>
  </div>
</div>
